import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Shield = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.5 11.6145L11 13.111L14.5 9.6193M20 11.7765V7.05281C20 6.20086 19.4578 5.4429 18.6502 5.16595L12.6502 3.10837C12.2288 2.96388 11.7712 2.96388 11.3498 3.10837L5.34984 5.16595C4.54224 5.4429 4 6.20086 4 7.05281V11.7765C4 16.7371 8 18.8472 12 21C16 18.8472 20 16.7371 20 11.7765Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9752 2.16256C12.3432 1.94577 11.6568 1.94577 11.0248 2.16256L5.02476 4.22063C3.81336 4.63616 3 5.77337 3 7.0516V11.7764C3 14.5771 4.14891 16.5955 5.8125 18.1671C7.38493 19.6525 9.44484 20.7609 11.3681 21.7958L11.5252 21.8803C11.8215 22.0399 12.1785 22.0399 12.4748 21.8803L12.6319 21.7958C14.5552 20.7609 16.6151 19.6525 18.1875 18.1671C19.8511 16.5955 21 14.5771 21 11.7764V7.0516C21 5.77337 20.1866 4.63616 18.9752 4.22063L12.9752 2.16256ZM15.0303 10.1475C15.3232 9.85526 15.3232 9.38141 15.0303 9.08915C14.7374 8.79688 14.2626 8.79688 13.9697 9.08915L11 12.0524L10.0303 11.0848C9.73744 10.7926 9.26256 10.7926 8.96967 11.0848C8.67678 11.3771 8.67678 11.851 8.96967 12.1432L10.4697 13.64C10.7626 13.9323 11.2374 13.9323 11.5303 13.64L15.0303 10.1475Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
